import React from 'react';
import { trackAddToCartAndRedirect } from '../utils/metaPixel';
export function BonusSection() {
  const bonuses = [{
    id: 1,
    title: 'The 72-Hour Get Home Bag',
    value: '$97',
    image: 'https://cdn.magicpatterns.com/uploads/enFhspo8AfQewUYfiici3n/mockup_72.png',
    description: "Don't get stranded. If the grid goes down while you're at work, this mobile-optimized guide shows you exactly how to bypass traffic and get home to your family on foot or by car."
  }, {
    id: 2,
    title: 'When 911 Takes Hours to Arrive: Will You Be Ready?',
    value: '$97',
    image: 'https://cdn.magicpatterns.com/uploads/idQQb54ZPEuRphxDKPxcEk/mockup_911.png',
    description: "Ambulances won't come during a city-wide crisis. Learn how to stop major bleeding, treat shock, and save lives using only what's in your home trauma kit."
  }, {
    id: 3,
    title: 'The Grey Man Security Protocol',
    value: '$67',
    image: 'https://cdn.magicpatterns.com/uploads/eHfhugkuRS3FrTFDpKPps5/mockup_grey.png',
    description: 'Security through invisibility. Learn how to reinforce your doors for $20 and keep your lights on without your neighbors knowing you have supplies.'
  }];
  return <section className="bg-white py-20 px-4" data-id="element-1">
      <div className="max-w-5xl mx-auto" data-id="element-2">
        <div className="text-center mb-16" data-id="element-3">
          <h2 className="text-3xl md:text-4xl font-montserrat font-extrabold text-black mb-4" data-id="element-4">
            Order Today And Get These 3 Total Security Bonuses
          </h2>
          <p className="text-xl text-brand-orange font-bold" data-id="element-5">
            Included completely FREE with your $9.99 order today.
          </p>
        </div>
        <div className="space-y-12" data-id="element-6">
          {bonuses.map(bonus => <div key={bonus.id} className="flex flex-col md:flex-row items-center gap-8 bg-white border-2 border-brand-orange/20 rounded-2xl p-6 md:p-10 shadow-lg hover:border-brand-orange/40 transition-colors" data-id="element-7">
              <div className="w-full md:w-2/5 flex-shrink-0" data-id="element-8">
                <img src={bonus.image} alt={bonus.title} className="w-full h-auto object-cover rounded-xl shadow-md" data-id="element-9" />
              </div>
              <div className="w-full md:w-3/5" data-id="element-10">
                <div className="inline-block bg-brand-orange text-white text-sm font-bold px-3 py-1 rounded-full mb-4 uppercase tracking-wide" data-id="element-11">
                  Bonus #{bonus.id}
                </div>
                <h3 className="text-2xl md:text-3xl font-montserrat font-bold text-black mb-2" data-id="element-12">
                  {bonus.title}
                </h3>
                <p className="text-zinc-500 font-semibold mb-4" data-id="element-13">
                  Regular Price:{' '}
                  <span className="line-through" data-id="element-14">{bonus.value}</span>{' '}
                  <span className="text-green-600 ml-2" data-id="element-15">Yours FREE</span>
                </p>
                <p className="text-zinc-700 text-lg leading-relaxed" data-id="element-16">
                  "{bonus.description}"
                </p>
              </div>
            </div>)}
        </div>{' '}
        <br data-id="element-17" />
        <div className="text-center" data-id="element-18">
          <a href="https://pay.hotmart.com/X104929887V?checkoutMode=10" target="_blank" rel="noopener noreferrer" onClick={trackAddToCartAndRedirect} className="btn-crunchy block w-full md:w-auto px-12 py-6 text-xl md:text-2xl mx-auto mb-6" data-id="element-19">
            CLAIM MY BONUSES — ONLY $9.99
          </a>
          <p className="text-zinc-500 text-sm" data-id="element-20">
            One-time payment. No hidden fees. Instant digital delivery.
          </p>
        </div>
      </div>
    </section>;
}